"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleUtils = exports.SALE_DISCOUNT_VALUE_4 = exports.SALE_DISCOUNT_VALUE_3 = exports.SALE_DISCOUNT_VALUE_2 = exports.SALE_DISCOUNT_VALUE_1 = void 0;
exports.SALE_DISCOUNT_VALUE_1 = 1000;
exports.SALE_DISCOUNT_VALUE_2 = 2000;
exports.SALE_DISCOUNT_VALUE_3 = 5000;
exports.SALE_DISCOUNT_VALUE_4 = 10000;
var SaleUtils = /** @class */ (function () {
    function SaleUtils() {
    }
    SaleUtils.vd = function (game, amount) {
        var _vd = 0;
        if (amount >= exports.SALE_DISCOUNT_VALUE_1 && amount < exports.SALE_DISCOUNT_VALUE_2) {
            _vd = game.price_500;
        }
        else if (amount >= exports.SALE_DISCOUNT_VALUE_2 && amount < exports.SALE_DISCOUNT_VALUE_3) {
            _vd = game.price_1000;
        }
        else if (amount >= exports.SALE_DISCOUNT_VALUE_3 && amount < exports.SALE_DISCOUNT_VALUE_4) {
            _vd = game.price_1500;
        }
        else if (amount >= exports.SALE_DISCOUNT_VALUE_4) {
            _vd = game.price_2500;
        }
        return _vd;
    };
    return SaleUtils;
}());
exports.SaleUtils = SaleUtils;
